const defaultState = {
    announcements: [],
    fetchAnnouncementsFailed: false
}

export function announcerData(state = defaultState, action) {
    switch (action.type) {
        case 'ANNOUNCEMENTS_FETCH':
            return { ...state, announcements: action.data };
        case 'ANNOUNCEMENTS_FETCH_FAILED':
            return { ...state, fetchAnnouncementsFailed: action.data };
        default:
            return state;
    }
}